import { VocabularyTest } from "./VocabularyTest";
export default VocabularyTest;
